import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAdminArticles, deleteArticle } from '../../api';

function AdminList() {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        loadArticles();
    }, []);

    const loadArticles = async () => {
        try {
            const res = await getAdminArticles();
            setArticles(res.data);
        } catch (err) {
            console.error('Error loading articles:', err);
            setMessage({ type: 'error', text: 'Errore nel caricamento degli articoli' });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id, title) => {
        if (!window.confirm(`Sei sicuro di voler eliminare "${title}"?`)) {
            return;
        }

        try {
            await deleteArticle(id);
            setArticles(articles.filter(a => a.id !== id));
            setMessage({ type: 'success', text: 'Articolo eliminato con successo!' });
        } catch (err) {
            console.error('Error deleting article:', err);
            setMessage({ type: 'error', text: 'Errore nell\'eliminazione dell\'articolo' });
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('it-IT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <>
            <header className="admin-header">
                <h1>Gestione Articoli</h1>
            </header>

            <div className="admin-content">
                {message && (
                    <div className={`alert alert-${message.type}`}>
                        {message.text}
                    </div>
                )}

                <div className="admin-toolbar">
                    <Link to="/admin/blog/create" className="btn btn-primary">
                        + Nuovo Articolo
                    </Link>
                </div>

                <div className="articles-table-wrapper">
                    <table className="articles-table">
                        <thead>
                            <tr>
                                <th>Immagine</th>
                                <th>Titolo</th>
                                <th>Categoria</th>
                                <th>Stato</th>
                                <th>Data Pubblicazione</th>
                                <th>Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" className="empty-state">
                                        Caricamento...
                                    </td>
                                </tr>
                            ) : articles.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="empty-state">
                                        Nessun articolo presente.{' '}
                                        <Link to="/admin/blog/create">Crea il primo articolo</Link>
                                    </td>
                                </tr>
                            ) : (
                                articles.map(article => (
                                    <tr key={article.id}>
                                        <td className="col-image">
                                            {article.cover_image_url ? (
                                                <img
                                                    src={`${article.cover_image_url}`}
                                                    alt=""
                                                    className="thumb"
                                                />
                                            ) : (
                                                <div className="thumb-placeholder">-</div>
                                            )}
                                        </td>
                                        <td className="col-title">
                                            <strong>{article.title}</strong>
                                            <span className="slug">/blog/{article.slug}</span>
                                        </td>
                                        <td>{article.category || '-'}</td>
                                        <td>
                                            <span className={`status-badge ${article.status === 1 ? 'published' : 'draft'}`}>
                                                {article.status === 1 ? 'Pubblicato' : 'Bozza'}
                                            </span>
                                        </td>
                                        <td>{formatDate(article.published_at)}</td>
                                        <td className="col-actions">
                                            <Link
                                                to={`/admin/blog/edit/${article.id}`}
                                                className="btn btn-sm btn-edit"
                                                title="Modifica"
                                            >
                                                ✏️
                                            </Link>
                                            <a
                                                href={`/blog/${article.slug}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-view"
                                                title="Visualizza"
                                            >
                                                👁️
                                            </a>
                                            <button
                                                onClick={() => handleDelete(article.id, article.title)}
                                                className="btn btn-sm btn-delete"
                                                title="Elimina"
                                            >
                                                🗑️
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default AdminList;
